// Mock data for Ludovic Garcia Photography website

// Dev-only debug logger — stripped in production builds (process.env.NODE_ENV is
// 'production' in CRA builds, so the console call is never executed there).
const devDebug = (...args) => {
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line no-console
    console.debug(...args);
  }
};

export const LOGO_URL = "/logo-light.png";

export const SITE_INFO = {
  name: "Garcia Ludovic",
  subtitle: "Photographe",
  location: "Fos Sur Mer",
  phone: "06 26 63 12 79",
  email: "contact@ludovic-garcia-photographe.fr",
  social: {
    instagram: "https://instagram.com/Ludovic_garcia_photography",
    instagramHandle: "Ludovic_garcia_photography",
    snapchat: "lgphotography13",
    tiktok: "https://tiktok.com/@lgphotography13",
    tiktokHandle: "lgphotography13",
    facebook: "Ludovic Garcia",
    facebookPage: "Ludovic garcia photography",
    google: "Ludovic Garcia Photography"
  }
};

export const HERO_TEXT = {
  title: "Garcia Ludovic",
  subtitle: "Photographe",
  tagline: "Capturer l'instant, sublimer l'émotion",
  intro: "Bonjour et bienvenue dans mon univers.",
  description: "Je suis de Fos Sur Mer et je peux me déplacer dans toute la France si défraiement pris en compte. Création de books en ligne / papier et shootings sur demande.",
  specialties: "PHOTOS",
  events: "Événementiels : Mariage, Baptême, Anniversaire, Grossesse, Naissance, etc.",
  closing: "Je suis ouvert à vos divers projets. Au plaisir de vous lire, je reste à votre entière disposition pour tout renseignements complémentaires."
};

// Compute deposit: 30% rounded to nearest euro (or override per tarif)
export const computeDeposit = (tarif) => {
  if (tarif.deposit) return tarif.deposit; // explicit value for mariage/bapteme
  return Math.round(tarif.price * 0.3);
};

export const TARIFS = [
  {
    id: "mariage",
    title: "Photos Mariage",
    price: 900,
    priceDisplay: "900€",
    featured: true,
    icon: "Heart",
    image: "/gallery/mariage/1.jpg",
    description: [
      "Je me déplace à la journée, des préparatifs à la pièce montée.",
      "Photos illimités envoyés sous 24 heures par email ou sur clefs USB.",
      "Les photos seront retouchées et signées.",
      "Un acompte de 250€ par RIB ou PAYPAL est demandé pour bloquer la date et l'heure de l'événement."
    ],
    deposit: 250
  },
  {
    id: "bapteme",
    title: "Photos Baptême",
    price: 450,
    priceDisplay: "450€",
    icon: "Church",
    image: "/gallery/enfant/1.jpg",
    description: [
      "Photos illimités envoyés sous 24 heures par email ou sur clefs USB.",
      "Les photos seront retouchées et signées.",
      "Un acompte de 180€ par RIB ou PAYPAL est demandé pour bloquer la date et l'heure de l'événement."
    ],
    deposit: 180
  },
  {
    id: "grossesse",
    title: "Shooting photos grossesse",
    price: 250,
    priceDisplay: "250€",
    icon: "Flower2",
    image: "/gallery/grossesse/1.jpg",
    description: [
      "Je reçois à domicile ou je me déplace.",
      "2 tenues de votre choix.",
      "20 photos retouchées et signées sur l'ensemble de vos photos choisi.",
      "Photos envoyées par email le jour même."
    ]
  },
  {
    id: "naissance",
    title: "Shooting photos naissance",
    price: 250,
    priceDisplay: "250€",
    icon: "Baby",
    image: "/gallery/famille/1.jpg",
    description: [
      "Je reçois à domicile ou je me déplace.",
      "20 photos retouchées et signées sur l'ensemble de vos photos choisi.",
      "Photos envoyées par email le jour même."
    ]
  },
  {
    id: "couple",
    title: "Couple / Duo",
    price: 250,
    priceDisplay: "250€",
    featured: true,
    icon: "Users",
    image: "https://res.cloudinary.com/dim01mwwq/image/upload/ludovic-garcia/duo/1f50a41d-00ac-4da3-a691-fea6dd161065.jpg",
    description: [
      "3 tenues au choix pour chaque personne.",
      "30 photos sélectionnées sur l'ensemble des photos.",
      "Les photos seront retouchées et signées à vos côtés et vous partez directement avec vos photos.",
      "Pas d'attente à recevoir vos photos."
    ]
  },
  {
    id: "shooting",
    title: "Photos",
    price: 180,
    priceDisplay: "180€",
    featured: true,
    icon: "Camera",
    image: "/gallery/portrait/1.jpg",
    description: [
      "3 tenues au choix.",
      "20 photos sélectionnées sur l'ensemble des photos.",
      "Les photos seront retouchées et signées à vos côtés et vous partez directement avec vos photos.",
      "Pas d'attente à recevoir vos photos."
    ]
  },
  {
    id: "book",
    title: "Book photos en ligne ou book photos papier",
    price: 400,
    priceDisplay: "400€",
    icon: "BookOpen",
    image: "/gallery/mode/1.jpg",
    description: [
      "8 tenues de votre choix.",
      "50 photos sélectionnées sur l'ensemble de vos photos.",
      "Les photos seront retouchées et signées à vos côtés et vous partez avec vos photos.",
      "Pas d'attente à recevoir vos photos.",
      "Le book en ligne sera actif sous 24 heures.",
      "Le book papier vous sera envoyé sous 72 heures."
    ]
  }
];

export const DEROULEMENT = [
  { num: 1, text: "Vous venez avec les tenues de votre choix." },
  { num: 2, text: "Je vous dirigerai pendant la session photos." },
  { num: 3, text: "Je mettrai ensuite toutes vos photos sur mon PC et vous choisirez vos photos préférées selon votre tarif choisi 20 ou 50 photos sur l'ensemble de vos photos. Les photos seront retouchées à vos côtés le jour même de la séance." },
  { num: 4, text: "Une fois les photos retouchées à vos côtés, elles vous seront envoyées sur votre téléphone. En AirDrop pour iPhone et en câble pour autres téléphones." },
  { num: 5, text: "Une fois vos photos sur votre téléphone portable, je les supprime devant vous de mon PC." }
];

// 19 gallery categories - ordre final défini par Ludovic
export const GALLERY_CATEGORIES = [
  { id: "mariage", name: "Mariage", cover: "/gallery/mariage/1.jpg" },
  { id: "grossesse", name: "Grossesse", cover: "/gallery/grossesse/1.jpg" },
  { id: "famille", name: "Famille", cover: "/gallery/famille/1.jpg" },
  { id: "enfant", name: "Enfants", cover: "/gallery/enfant/1.jpg" },
  { id: "portrait", name: "Portrait", cover: "/gallery/portrait/1.jpg" },
  { id: "mode", name: "Mode", cover: "/gallery/mode/1.jpg" },
  { id: "maillot", name: "Maillot de bain", cover: "/gallery/maillot/1.jpg" },
  { id: "duo", name: "Duo", cover: "https://ludovic-garcia-photography.book.fr/files/1/187933/g_10_qir4Gx0Ey5.jpg" },
  { id: "noir-blanc", name: "Noir et blanc", cover: "https://ludovic-garcia-photography.book.fr/files/1/187933/g_10_DHxlDXz06Hph.jpg" },
  { id: "ombre", name: "Jeu d'ombre", cover: "https://ludovic-garcia-photography.book.fr/files/1/187933/g_10_EwzkIGm1cx.jpg" },
  { id: "neon", name: "Néon", cover: "https://ludovic-garcia-photography.book.fr/files/1/187933/g_10_NfKr6V78Qkw9.jpg" },
  { id: "homme", name: "Homme", cover: "https://ludovic-garcia-photography.book.fr/files/1/187933/g_10_S8NEfKuZ9Vkz.jpg" },
  { id: "streetwear", name: "Streetwear", cover: "https://ludovic-garcia-photography.book.fr/files/1/187933/g_10_StXw1yG549.jpg" },
  { id: "chevaux", name: "Chevaux", cover: "https://ludovic-garcia-photography.book.fr/files/1/187933/g_10_ps5hS2i4qQIh.jpg" },
  { id: "voiture", name: "Voiture", cover: "https://ludovic-garcia-photography.book.fr/files/1/187933/g_10_yWgflrzH9JAK.jpg" },
  { id: "moto", name: "Moto", cover: "https://ludovic-garcia-photography.book.fr/files/1/187933/g_10_fPjnxOE57t.jpg" },
  { id: "evenement", name: "Événement", cover: "https://ludovic-garcia-photography.book.fr/files/1/187933/g_10_Ab1lvL2nYj.jpg" },
  { id: "cowgirl", name: "Cowgirl", cover: "https://ludovic-garcia-photography.book.fr/files/1/187933/g_10_rbpMDxgwIM86.jpg" },
  { id: "animaux", name: "Animaux", cover: "https://ludovic-garcia-photography.book.fr/files/1/187933/g_10_klsy1pEnCe.jpg" }
];

// Placeholder sub-gallery images per category (will be replaced with real HD photos from Ludovic)
export const GALLERY_SUB_IMAGES = {
  portrait: [
    "/gallery/portrait/1.jpg",
    "/gallery/portrait/2.jpg",
    "/gallery/portrait/3.jpg",
    "/gallery/portrait/4.jpg",
    "/gallery/portrait/5.jpg"
  ],
  mode: [
    "/gallery/mode/1.jpg",
    "/gallery/mode/2.jpg",
    "/gallery/mode/3.jpg",
    "/gallery/mode/4.jpg",
    "/gallery/mode/5.jpg"
  ],
  mariage: [
    "/gallery/mariage/1.jpg",
    "/gallery/mariage/2.jpg",
    "/gallery/mariage/3.jpg",
    "/gallery/mariage/4.jpg",
    "/gallery/mariage/5.jpg"
  ],
  grossesse: [
    "/gallery/grossesse/1.jpg",
    "/gallery/grossesse/2.jpg",
    "/gallery/grossesse/3.jpg",
    "/gallery/grossesse/4.jpg",
    "/gallery/grossesse/5.jpg"
  ],
  naissance: [
    "https://ludovic-garcia-photography.book.fr/files/1/187933/g_10_bkIss8Aaj8.jpg",
    "https://images.unsplash.com/photo-1551137583-c1f35e60434a",
    "https://images.unsplash.com/photo-1562494566-35b48599c943",
    "https://images.pexels.com/photos/16381748/pexels-photo-16381748.jpeg",
    "https://images.pexels.com/photos/16381749/pexels-photo-16381749.jpeg"
  ],
  famille: [
    "/gallery/famille/1.jpg",
    "/gallery/famille/2.jpg",
    "/gallery/famille/3.jpg",
    "/gallery/famille/4.jpg",
    "/gallery/famille/5.jpg"
  ],
  enfant: [
    "/gallery/enfant/1.jpg",
    "/gallery/enfant/2.jpg",
    "/gallery/enfant/3.jpg",
    "/gallery/enfant/4.jpg",
    "/gallery/enfant/5.jpg"
  ],
  maillot: [
    "/gallery/maillot/1.jpg",
    "/gallery/maillot/2.jpg",
    "/gallery/maillot/3.jpg",
    "/gallery/maillot/4.jpg",
    "/gallery/maillot/5.jpg"
  ]
};

// For any category without sub-images, use the cover as only image
export const getCategoryImages = (catId) => {
  const defaults = GALLERY_SUB_IMAGES[catId] || [];
  if (defaults.length > 0) return defaults;
  const cat = GALLERY_CATEGORIES.find(c => c.id === catId);
  return cat ? [cat.cover] : [];
};

// Returns only the hardcoded sub-images (real local /gallery/<cat>/*.jpg files).
// Does NOT fall back to the single book.fr cover.
export const getHardcodedSubImages = (catId) => GALLERY_SUB_IMAGES[catId] || [];

export const HERO_IMAGE = "https://images.unsplash.com/photo-1500648767791-00dcc994a43e";

export const GIFT_CARDS = [
  { id: "shooting", title: "Photos", price: 180, icon: "Camera", description: "3 tenues, 20 photos retouchées et signées sur place. Vous repartez directement avec vos photos.", image: "/gallery/portrait/1.jpg" },
  { id: "grossesse", title: "Séance Grossesse", price: 250, icon: "Flower2", description: "2 tenues, 20 photos retouchées et signées. Séance à domicile ou déplacement.", image: "/gallery/grossesse/1.jpg" },
  { id: "naissance", title: "Séance Naissance", price: 250, icon: "Baby", description: "20 photos retouchées et signées. Séance à domicile ou déplacement.", image: "/gallery/famille/1.jpg" },
  { id: "book", title: "Book Photos", price: 400, icon: "BookOpen", description: "8 tenues, 50 photos retouchées et signées sur place. Book en ligne ou papier.", image: "/gallery/mode/1.jpg" },
  { id: "bapteme", title: "Reportage Baptême", price: 450, icon: "Church", description: "Photos illimitées retouchées et signées, envoyées sous 24h par email ou clé USB.", image: "/gallery/enfant/1.jpg" },
  { id: "mariage", title: "Reportage Mariage", price: 900, icon: "Heart", description: "Journée complète, des préparatifs à la pièce montée. Photos illimitées retouchées et signées.", image: "/gallery/mariage/1.jpg" }
];

export const isDateBlocked = (date) => {
  const d = new Date(date);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  if (d < today) return true;
  const blockedKeys = getMockBlockedKeys();
  const key = d.toISOString().split('T')[0];
  if (blockedKeys.includes(key)) return true;
  return false;
};

const getMockBlockedKeys = () => {
  try {
    const stored = localStorage.getItem('ludovic_blocked_dates');
    if (stored) return JSON.parse(stored);
  } catch (e) { devDebug('[mock] blocked_dates parse failed', e); }
  return [];
};

export const setMockBlockedDates = (dates) => {
  localStorage.setItem('ludovic_blocked_dates', JSON.stringify(dates));
};

export const getMockBookings = () => {
  try {
    const stored = localStorage.getItem('ludovic_bookings');
    if (stored) return JSON.parse(stored);
  } catch (e) { devDebug('[mock] bookings parse failed', e); }
  return [];
};

export const addMockBooking = (booking) => {
  const bookings = getMockBookings();
  const newBooking = { ...booking, id: Date.now().toString(), createdAt: new Date().toISOString(), status: 'en_attente' };
  bookings.push(newBooking);
  localStorage.setItem('ludovic_bookings', JSON.stringify(bookings));
  return newBooking;
};

export const getMockGiftCards = () => {
  try {
    const stored = localStorage.getItem('ludovic_gift_cards');
    if (stored) return JSON.parse(stored);
  } catch (e) { devDebug('[mock] gift_cards parse failed', e); }
  return [];
};

export const addMockGiftCard = (card) => {
  const cards = getMockGiftCards();
  const code = 'LG-' + Math.random().toString(36).substring(2, 8).toUpperCase() + '-' + Math.random().toString(36).substring(2, 6).toUpperCase();
  const newCard = { ...card, id: Date.now().toString(), code, createdAt: new Date().toISOString(), status: 'active', used: false };
  cards.push(newCard);
  localStorage.setItem('ludovic_gift_cards', JSON.stringify(cards));
  return newCard;
};

// ===== ADMIN PHOTOS MANAGEMENT =====
// Admin uploads photos (stored as base64 in localStorage for mock)
export const getAdminPhotos = () => {
  try {
    const stored = localStorage.getItem('ludovic_admin_photos');
    if (stored) return JSON.parse(stored);
  } catch (e) { devDebug('[mock] admin_photos parse failed', e); }
  return [];
};

export const addAdminPhoto = (photo) => {
  const photos = getAdminPhotos();
  const newPhoto = {
    ...photo,
    id: Date.now().toString() + Math.random().toString(36).substring(2, 6),
    createdAt: new Date().toISOString()
  };
  photos.push(newPhoto);
  try {
    localStorage.setItem('ludovic_admin_photos', JSON.stringify(photos));
  } catch (e) {
    // localStorage quota exceeded
    throw new Error('Espace de stockage saturé. Supprimez des photos ou utilisez des images plus petites.');
  }
  return newPhoto;
};

export const deleteAdminPhoto = (id) => {
  const photos = getAdminPhotos().filter(p => p.id !== id);
  localStorage.setItem('ludovic_admin_photos', JSON.stringify(photos));
};

export const getPhotosByCategory = (catId) => {
  return getAdminPhotos().filter(p => p.category === catId);
};
